import { Card, CardActionArea, CardProps } from "@mui/material";
import * as React from "react";

type SquareCardProps = CardProps & {
  onClick?: () => void;
};

function SquareCard({ children, onClick, ...props }: SquareCardProps) {
  return (
    <Card
      square
      {...props}
      sx={{ border: 1, borderColor: "secondary.main", ...props.sx }}
    >
      {onClick ? (
        <CardActionArea onClick={onClick}>{children}</CardActionArea>
      ) : (
        children
      )}
    </Card>
  );
}

export { SquareCard };
export type { SquareCardProps };
